































































import { Vue, Component, Watch } from "vue-property-decorator";
import { getCurrentUserId } from "@/plugins/roles";
import { PracticePassList as IPracticePassList } from "@/api/models/practice-pass-list";
import practicePass, {
  PracticePassListParams
} from "@/getinfo-api/practice-pass";
import api from "@/getinfo-api";
import { PracticePass as IPracticePass } from "@/api/models/practice-pass";
import { Course as ICourse } from "@/api/models/course";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import course, { CourseListParams } from "@/getinfo-api/course";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import PracticePassListItem from "@/components/practice/PracticePassListItem.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CustomTable from "@/components/form/CustomTable.vue";

@Component({
  components: { CustomTable, CSingleSelect, PracticePassListItem }
})
export default class PracticePassForUserList extends Vue {
  practicePasses: Array<IPracticePass> = [];
  courses!: Array<ICourse>;
  selectedCourseId!: string;
  listener!: ICourseListener;
  showSpinner: boolean = false;

  data() {
    return {
      courses: undefined,
      selectedCourseId: undefined,
      listener: undefined
    };
  }

  get userId() {
    return getCurrentUserId();
  }

  getMyCourses() {
    this.showSpinner = true;
    let params: CourseListParams = {
      listenerUserIds: [this.userId],
      limit: 300
    };
    course(params)
      .then((res: { data: ICoursesList }) => {
        this.courses = res.data?.courses;
        this.courses = this.courses.filter(el => {
          return el.practice && el.practice.enabled;
        });
        this.selectedCourseId = res.data.courses[0].id;
        this.getMyListenerIdByCourseId();
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getMyListenerIdByCourseId() {
    this.showSpinner = true;
    this.practicePasses = [];
    api.CourseApi.listenerGetActiveByUser(this.selectedCourseId, this.userId)
      .then((res: { data: ICourseListener }) => {
        this.listener = res.data;
        this.getMyPracticePasses(this.listener.id);
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getMyPracticePasses(listenerId: string) {
    this.showSpinner = true;
    let param: PracticePassListParams = {
      id: this.selectedCourseId,
      listenerId: listenerId
    };
    practicePass(param)
      .then((res: { data: IPracticePassList }) => {
        this.practicePasses = res.data.practices;
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }
  get screenWidth() {
    return window.innerWidth;
  }

  @Watch("selectedCourseId")
  updatePracticePasses() {
    this.getMyListenerIdByCourseId();
  }

  created() {
    this.getMyCourses();
  }
}
